var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.769-200q-13.154 0-21.962-8.807Q440-217.615 440-230.769v-223.077L221-731.154q-7.847-8.538-2.077-18.692 5.769-10.154 16-10.154h490.154q10.231 0 16 10.154 5.77 10.154-2.077 18.692L520-453.846v223.077q0 13.154-8.807 21.962Q502.385-200 489.231-200h-18.462ZM480-452.923l217.692-276.308H262.308L480-452.923Zm0 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.103acb2f96eb44e45fce50b31a1bbb01.svg";
export { ForwardRef as ReactComponent };